/** @format */

import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import LeftNavBar from '../../../Dashboard/LeftNavBar';

export default function MobileHeader(props) {
  const {
    show,
    setShow,
    buttonText,
    getButtonColor,
    registerAsBrokerUrl,
    hideHeaderButtons,
    dashboard
  } = props;

  return (
    <>
      <div
        className={`hamburger-menu-floating-button ${
          show
            ? 'hamburger-menu-floating-button-close'
            : 'hamburger-menu-floating-button-open'
        }`}
        onClick={() => setShow(!show)}></div>
      {show && (
        <div className={`mobile-header-overlay ${dashboard && `dashboard`}`}>
          {dashboard && (
            <LeftNavBar
              logOutModalText={props.t('lang_broker:logoutModal')}
              leftBarNavText={props.t('lang_broker:leftbarnav')}
              setShow={setShow}
            />
          )}

          {!hideHeaderButtons &&
            !dashboard &&
            buttonText.map((item, key) => (
              <div className={`mobile-header-button-item`} key={key}>
                {key === 1 && (
                  <a href={registerAsBrokerUrl} target='_self'>
                    <Button className={`btn btn-${getButtonColor(key)}`}>
                      {item.text}
                    </Button>
                  </a>
                )}
                {key === 0 && (
                  <Link to={item.props.url}>
                    <Button className={`btn btn-${getButtonColor(key)}`}>
                      {item.text}
                    </Button>
                  </Link>
                )}
              </div>
            ))}
        </div>
      )}
    </>
  );
}
